import React, { FC, startTransition } from "react";
import classes from "./SelectProductItemsHeader.module.scss";

import { useRecoilState, useRecoilValue } from "recoil";
import { productItemsState, userState } from "../../../../../states/userState";
import { foreColorPagination } from "../../../../../commons/colors";

const SelectProductItemsHeader = (props) => {
  const {
    checkedItems,
    setCheckedItems,
    allProductItems,
    checkedItemsForUi,
    setCheckedItemsForUi,
  } = props;
  const user = useRecoilValue(userState);
  const [isAllHoverd, setIsAllHovered] = React.useState(false);
  const [isClearHovered, setIsClearHovered] = React.useState(false);

  const handleSelectAll = () => {
    setCheckedItemsForUi(allProductItems);
    startTransition(() => {
      setCheckedItems(allProductItems);
    });
  };
  const handleClear = () => {
    setCheckedItemsForUi([]);
    startTransition(() => {
      setCheckedItems([]);
    });
  };
  return (
    <div className={classes.rootContainer}>
      <p
        className={classes.name}
        style={foreColorPagination(user?.mode ?? "lite")}
      >
        品目
      </p>
      <div className={classes.leftContent}>
        <div
          style={{
            // backgroundColor: "#09a0f2",
            backgroundColor: isAllHoverd ? "#ff0" : "#09a0f2",
            width: "60px",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "5px",
            cursor: "pointer",
            marginRight: "20px",
            fontSize: "14px",
            lineHeight: "30px",
          }}
          onMouseEnter={() => setIsAllHovered(true)} // マウスが要素に入ったらホバー状態をtrueに
          onMouseLeave={() => setIsAllHovered(false)} // マウスが要素から出たらホバー状態をfalseに
          onClick={handleSelectAll}
        >
          すべて
        </div>
        <div>
          <div
            style={{
              // backgroundColor: "#09a0f2",
              backgroundColor: isClearHovered ? "#ff0" : "#09a0f2",
              width: "60px",
              height: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "5px",
              cursor: "pointer",
              marginRight: "20px",
              fontSize: "14px",
              lineHeight: "30px",
            }}
            onMouseEnter={() => setIsClearHovered(true)} // マウスが要素に入ったらホバー状態をtrueに
            onMouseLeave={() => setIsClearHovered(false)} // マウスが要素から出たらホバー状態をfalseに
            onClick={handleClear}
          >
            クリア
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectProductItemsHeader;
